// src/legal/legal.constants.ts
export const LRNSY_LEGAL = {
  platformName: "LRNSY",
  operator: "Electrixitaty Limited",
  website: "https://www.lrnsy.electrixitaty.com",
  supportEmail: "support@lrnsy.electrixitaty.com",
  legalEmail: "support@lrnsy.electrixitaty.com",
  privacyEmail: "support@lrnsy.electrixitaty.com",
  businessAddress: "Nairobi, Kenya",
  jurisdiction: "Kenya",
  effectiveDate: "10 May 2026",
  lastUpdated: "10 May 2026",
  privacyPath: "/privacy",
  termsPath: "/terms",
  settingsPath: "/settings/privacy",
} as const;

export const CONSENT_STORAGE_KEY = "lrnsy_privacy_consent_v1";
export const LEGAL_AGREEMENT_STORAGE_KEY = "lrnsy_legal_agreement_v1";
export const LOCAL_DRAFTS_KEY = "lrnsy_local_create_draft";
export const PENDING_FINALIZE_KEY = "lrnsy_pending_finalize_after_auth";

export const REQUIRED_LEGAL_VERSION = {
  termsVersion: "2026-05-10",
  privacyVersion: "2026-05-10",
  cookiesVersion: "2026-05-10",
} as const;
